import { useAppSelector } from 'hooks';
import React, { useState } from 'react';
import styles from './styles.module.sass';
import { ListFilter, ListItem } from './components/components';

export const FacilitiesList = () => {
  const { facilities } = useAppSelector(({ facility }) => facility);
  const [filterQuery, setFilterQuery] = useState('');

  if (!facilities.length) {
    return <h3>No facilities</h3>;
  }

  const filteredFacilities = filterQuery
    ? facilities.filter((facility) => facility.name.toLowerCase().includes(filterQuery.toLowerCase()))
    : facilities;

  return (
    <div className={styles.container}>
      <h3>Facilities list:</h3>
      <ListFilter onFilterQuery={setFilterQuery} />
      <div className={styles.facilities_container}>
        {filteredFacilities.map((facility) => (
          <ListItem key={facility.id} {...facility} />
        ))}
      </div>
    </div>
  );
};
